module.exports = __webpack_public_path__ + "static/minneapolis-03e2c245f9a4ae6506b0a15cd365b76b.png";